import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1311.32612,891.546353 L1249.66024,829.880471 L1356.95435,722.473412 L1197.25553,562.774588 L1089.73553,670.407529 L1028.18259,610.096941 L1412.52141,225.193412 L1694.64847,506.642824 L1311.32612,891.546353 Z M891.862588,1309.42871 L508.540235,1694.33224 L225.396706,1412.88282 L609.735529,1027.97929 L670.949647,1089.19341 L560.944941,1199.08518 L720.643765,1358.784 L830.761412,1248.77929 L891.862588,1309.42871 Z M1854.34729,347.508706 L1571.31671,64.4781176 C1482.77082,-21.8089412 1340.12612,-21.4701176 1253.38729,65.4945882 L868.483765,450.398118 C780.954353,538.040471 780.954353,680.459294 868.483765,768.101647 L930.149647,829.880471 L830.648471,929.381647 L770.337882,869.184 C728.210824,826.040471 671.966118,802.096941 611.768471,801.758118 L610.413176,801.758118 C550.215529,801.758118 493.519059,825.362824 450.601412,868.167529 L65.6978824,1253.184 C-21.9444706,1340.82635 -21.9444706,1483.24518 65.6978824,1570.88753 L348.841412,1854.03106 C392.662588,1897.85224 450.149647,1919.76282 507.749647,1919.76282 C565.236706,1919.76282 622.836706,1897.85224 666.657882,1854.03106 L1051.56141,1469.12753 C1094.81788,1425.87106 1118.42259,1368.60988 1118.08376,1307.96047 C1117.632,1247.76282 1093.68847,1191.51812 1051.56141,1150.29459 L990.347294,1089.19341 L1089.96141,989.579294 L1151.62729,1051.35812 C1195.44847,1095.06635 1252.93553,1116.97694 1310.53553,1116.97694 C1368.02259,1116.97694 1425.62259,1095.06635 1469.33082,1051.24518 L1854.34729,666.341647 C1941.19906,579.489882 1941.65082,436.845176 1854.34729,347.508706 L1854.34729,347.508706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLinkSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconLinkSolid, _Component);

  var _super = _createSuper(IconLinkSolid);

  function IconLinkSolid() {
    _classCallCheck(this, IconLinkSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconLinkSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLink",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLinkSolid.displayName = "IconLinkSolid";
  return IconLinkSolid;
}(Component);

IconLinkSolid.glyphName = 'link';
IconLinkSolid.variant = 'Solid';
IconLinkSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLinkSolid;
export { IconLinkSolid };